(() => {
  if (window.sampleAudienceRoutesLoaded) return;
  window.sampleAudienceRoutesLoaded = true;

  function init(root = document) {
    root.querySelectorAll('form').forEach((form) => {
      const selector = form.querySelector('[data-sample-audience-selector]');
      const productSelector = form.querySelector('[data-sample-product-selector]');
      if ((!selector && !productSelector) || form.dataset.sampleAudienceReady) return;
      form.dataset.sampleAudienceReady = 'true';
      const groups = Array.from(form.querySelectorAll('[data-sample-audience-block]'));
      const disabled = new WeakMap();

      function update() {
        const route = selector && Array.from(selector.querySelectorAll('[data-sample-route]')).find(input => input.checked)?.dataset.sampleRoute;
        const product = productSelector && Array.from(productSelector.querySelectorAll('[data-sample-product]')).find(input => input.checked)?.dataset.sampleProduct;
        groups.forEach((group) => {
          const audienceMatches = !selector || group.dataset.sampleAudienceBlock === 'all' || group.dataset.sampleAudienceBlock === route;
          const productRule = group.dataset.sampleProductBlock || 'all';
          const productMatches = !productSelector || productRule === 'all' || productRule === product;
          const show = audienceMatches && productMatches;
          group.hidden = !show;
          group.querySelectorAll('input, select, textarea, button').forEach((input) => {
            if (!show) {
              if (!disabled.has(input)) disabled.set(input, input.disabled);
              input.disabled = true;
            } else if (disabled.has(input)) {
              input.disabled = disabled.get(input);
              disabled.delete(input);
            }
          });
        });
      }

      selector?.addEventListener('change', update);
      productSelector?.addEventListener('change', update);
      form.addEventListener('reset', () => setTimeout(update, 0));
      form.addEventListener('shopify:block:select', (event) => {
        const group = event.target.closest('[data-sample-audience-block]');
        const route = group?.dataset.sampleAudienceBlock;
        const input = selector?.querySelector(`[data-sample-route="${route}"]`);
        if (input) {
          input.checked = true;
        }
        const productInput = productSelector?.querySelector(`[data-sample-product="${group?.dataset.sampleProductBlock}"]`);
        if (productInput) productInput.checked = true;
        update();
      });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
